// GET /forecasts/today · POST /forecasts/answer · GET /forecasts/archive
import { z } from 'zod'
import { forecastAnswerSchema } from '../enums.js'
import { isoDateSchema, paginated, paginationQuerySchema } from './common.js'

export const forecastDtoSchema = z.object({
  date: isoDateSchema,
  text: z.string(),
  answer: forecastAnswerSchema.nullable(),
})
export type ForecastDto = z.infer<typeof forecastDtoSchema>

// GET /forecasts/today
export const todayForecastResponseSchema = forecastDtoSchema
export type TodayForecastResponse = z.infer<typeof todayForecastResponseSchema>

// POST /forecasts/answer — «сбылось» / «мимо» на сегодняшний прогноз.
export const answerForecastRequestSchema = z.object({
  answer: forecastAnswerSchema,
})
export type AnswerForecastRequest = z.infer<typeof answerForecastRequestSchema>
export const answerForecastResponseSchema = forecastDtoSchema
export type AnswerForecastResponse = z.infer<typeof answerForecastResponseSchema>

// GET /forecasts/archive — история + сырые счётчики для calcHitRate (contracts/domain/hitRate).
//
// `month` (YYYY-MM) сужает и список, и счётчики: статистика листается по месяцам, и «сбылось
// 7 из 9» обязано относиться к тому месяцу, который человек сейчас смотрит.
export const forecastArchiveQuerySchema = paginationQuerySchema.extend({
  month: z
    .string()
    .regex(/^\d{4}-\d{2}$/)
    .optional(),
})
export type ForecastArchiveQuery = z.infer<typeof forecastArchiveQuerySchema>
export const forecastArchiveResponseSchema = paginated(forecastDtoSchema).extend({
  hits: z.number().int().min(0),
  answered: z.number().int().min(0),
})
export type ForecastArchiveResponse = z.infer<typeof forecastArchiveResponseSchema>
